export default "__VITE_ASSET__f7ece2b0__"